import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { UsersAdmin } from "@/pages/admin/UsersAdmin";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/users",
  component: () => (
    <RoleGuard action="user_invite">
      <UsersAdmin />
    </RoleGuard>
  ),
});
